export const FORM_STEPS = [
    {
        id: 'choose-provider',
        path: 'velg-bank',
        translationKey: 'chooseProvider',
        requiredFields: [],
    },
    {
        id: 'source-account',
        path: 'fra-konto',
        translationKey: 'sourceAccount',
        requiredFields: ['bankProvider'],
    },
    {
        id: 'target-account',
        path: 'til-konto',
        translationKey: 'targetAccount',
        requiredFields: ['transferType'],
    },
    {
        id: 'confirmation',
        path: 'oppsummering',
        translationKey: 'confirmation',
        requiredFields: ['bankProvider', 'transferType', 'targetType'],
    },
    {
        id: 'receipt',
        path: 'kvittering',
        translationKey: 'receipt',
        requiredFields: [],
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1zdGVwcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9hcHBzL3RyYW5zZmVyLXNoYXJlLXNhdmluZ3MtYWNjb3VudC9jb25maWcvZm9ybS1zdGVwcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQWU7SUFDbEM7UUFDSSxFQUFFLEVBQUUsaUJBQWlCO1FBQ3JCLElBQUksRUFBRSxXQUFXO1FBQ2pCLGNBQWMsRUFBRSxnQkFBZ0I7UUFDaEMsY0FBYyxFQUFFLEVBQUU7S0FDckI7SUFDRDtRQUNJLEVBQUUsRUFBRSxnQkFBZ0I7UUFDcEIsSUFBSSxFQUFFLFdBQVc7UUFDakIsY0FBYyxFQUFFLGVBQWU7UUFDL0IsY0FBYyxFQUFFLENBQUMsY0FBYyxDQUFDO0tBQ25DO0lBQ0Q7UUFDSSxFQUFFLEVBQUUsZ0JBQWdCO1FBQ3BCLElBQUksRUFBRSxXQUFXO1FBQ2pCLGNBQWMsRUFBRSxlQUFlO1FBQy9CLGNBQWMsRUFBRSxDQUFDLGNBQWMsQ0FBQztLQUNuQztJQUNEO1FBQ0ksRUFBRSxFQUFFLGNBQWM7UUFDbEIsSUFBSSxFQUFFLGNBQWM7UUFDcEIsY0FBYyxFQUFFLGNBQWM7UUFDOUIsY0FBYyxFQUFFLENBQUMsY0FBYyxFQUFFLGNBQWMsRUFBRSxZQUFZLENBQUM7S0FDakU7SUFDRDtRQUNJLEVBQUUsRUFBRSxTQUFTO1FBQ2IsSUFBSSxFQUFFLFlBQVk7UUFDbEIsY0FBYyxFQUFFLFNBQVM7UUFDekIsY0FBYyxFQUFFLEVBQUU7S0FDckI7Q0FDSixDQUFDIn0=